module.exports = {"id":"dp4_2l1q3","text":"Protecting personal data and privacy","instructions":"Which situation may indicate an attempt to steal personal information?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"4.2","questionType":"PickOne","random":true,"options":[{"id":"dp4_2l1q3-a1","text":"Unexpected login request","score":1.8},{"id":"dp4_2l1q3-a2","text":"Normal account notice","score":0},{"id":"dp4_2l1q3-a3","text":"Regular service update","score":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat4.2/l1q3.json
// module id = 1225
// module chunks = 41